import React, { useState, useEffect } from 'react';
import './LoginIntermediary';
import { setCookie, getCookie } from 'cookies-next';
import jwtDecode from 'jwt-decode';
import { showMainIntermediary } from '../Intermediary/utilsIntermediary';
import { loginIntermediary } from '../../utils/api';
import { notify, notifyError } from '../../utils/notify';
import RegisterIntermediary from '../RegisterIntermediary/RegisterIntermediary';
import PasswordIntermediary from '../PasswordIntermediary/PasswordIntermediary';
import { INTERMEDIARY_TOKEN_COOKIE } from '../../utils/authCookies';

export default function LoginIntermediary() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenPassword, setModalOpenPassword] = useState(false);

  const openModalPassword = () => {
    setModalOpenPassword(true);
  };

  const closeModalPassword = () => {
    setModalOpenPassword(false);
  };

  const openModalRegister = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  useEffect(() => {
    const token = getCookie(INTERMEDIARY_TOKEN_COOKIE);
    if (token) {
      showMainIntermediary();
    }
  }, []);

  const checksInput = () => {
    var input = "";
    if (email === '') {
      input = "email";
      notify(input);
      return false;
    } else if (password === '') {
      input = "senha";
      notify(input);
      return false;
    }
    return true;
  }

  const getUserStatus = (loginData) => {
    let userData = loginData;

    if (loginData?.token) {
      try {
        userData = jwtDecode(loginData.token);
      } catch (error) {
        userData = loginData;
      }
    }

    if (typeof loginData === 'string') {
      try {
        userData = jwtDecode(loginData);
      } catch (error) {
        return '';
      }
    }

    return userData?.status
      || loginData?.status
      || userData?.intermediaryUser?.status
      || userData?.referrerUser?.status
      || userData?.consultantUser?.status
      || userData?.consultant?.status
      || userData?.user?.status
      || '';
  }

  const isActiveUser = (status) => {
    const normalizedStatus = String(status).trim().toUpperCase();
    return normalizedStatus === 'A';
  }

  const doLogin = async (event) => {
    event.preventDefault();

    if (!checksInput()) {
      return false;
    }

    const data = {
      email,
      password
    }

    try {
      const response = await loginIntermediary(data);

      if (response.status === 401) {
        var input = "Usuário ou senha incorretos";
        notifyError(input);
        return false;
      }
      const jsonToken = await response.json();

      if (!response.ok) {
        throw new Error(response.statusText);
      }

      if (jsonToken) {
        const userStatus = getUserStatus(jsonToken);
        const token = jsonToken.token || jsonToken;

        if (!isActiveUser(userStatus)) {
          notifyError('É necessária a liberação para acessar');
          return false;
        }

        setCookie(INTERMEDIARY_TOKEN_COOKIE, token, { path: '/' });

        showMainIntermediary();
      }
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <>
      <form className='p-8 pt-5 rounded-lg font-sans shadow-2xl shadow-blue-800/70' style={{ width: '400px', backgroundColor: '#004e80' }}>
        <h3 className='text-center normal-case text-white font-sans my-6 text-xl font-raleway font-medium'>Bem-vindo a Intermediação</h3>
        <div className='mb-4'>
          <input type="text" className='w-full bg-white rounded-lg h-10 p-3' placeholder='Login' value={email} onChange={(event) => setEmail(event.target.value)} />
        </div>
        <div className='mb-4'>
          <input type='password' className='w-full bg-white rounded-lg h-10 p-3' placeholder='Senha' value={password} onChange={(event) => setPassword(event.target.value)} />
        </div>
        <button type="submit" className='w-full text-white border-none rounded-lg py-2 px-4 cursor-pointer h-10 mb-4' onClick={doLogin} style={{ backgroundColor: '#c76f36' }}>Entrar</button>
        <div className='flex'>
          <div className='w-1/2'>
            <button type="button" className='w-full text-white border rounded-lg py-2 px-4 cursor-pointer h-10' onClick={openModalRegister} style={{ backgroundColor: '#004e80', border: '1px solid white' }}>Cadastre-se</button>
          </div>
          <div className='w-1/2'>
            <button type="button" className='w-full text-white border-none rounded-lg py-2 px-4 cursor-pointer h-10' onClick={openModalPassword} style={{ backgroundColor: '#004e80' }}>Esqueceu a senha?</button>
          </div>
        </div>
      </form>
      <RegisterIntermediary isOpen={modalOpen} closeModal={closeModal} />
      <PasswordIntermediary isOpen={modalOpenPassword} closeModal={closeModalPassword} />
    </>
  );
}
